import React from 'react';
import { Modal } from 'antd';
import CollectionV2Intake from 'routes/app/collectionIngreso/CollectionV2Intake';

interface Props {
  collectionId: number | null;
  onClose: () => void;
}

const CollectionIntakeModal: React.FC<Props> = ({
  collectionId,
  onClose,
}: Props) => (
  <Modal
    open={collectionId != null}
    onCancel={onClose}
    width={1000}
    footer={null}
    destroyOnClose
    title="Ingresar colecta al depósito"
  >
    {collectionId != null && (
      <CollectionV2Intake
        collectionId={collectionId}
        onReset={onClose}
        showBack={false}
      />
    )}
  </Modal>
);

export default CollectionIntakeModal;
